let config = {};

export const setAppConfig = (appConfig) => {
    if (appConfig) {
        config = appConfig;
    }
};

export const getAppConfig = () => config;